
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, questionsActions } from "../../../_actions";
import StudentHeader from "./Component/StudentHeader";
import Select from 'react-select';
import moment from "moment";

import AssessmentReport from "../../Surveylink/Component/AssessmentReport/AssessmentReport";
import AssessmentSummary from "../../Surveylink/Component/AssessmentSummary/AssessmentSummary";
import AssessmentManagerReport from "../../Surveylink/Component/AssessmentManagerReport/AssessmentManagerReport";
import AssessmentHiringReport from "../../Surveylink/Component/AssessmentHiringReport/AssessmentHiringReport";
import AssessmentReportSchool from "../../Surveylink/Component/AssessmentReportSchool/AssessmentReportSchool";
import AssessmentReportCareer from "../../Surveylink/Component/AssessmentReportCareer/AssessmentReportCareer";


class StudentReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: 100000,
      crr_class: "",
      showReportModal: false,
      crrEmployeeId: "",
      crrEmpDetails: {
        emp_id: "",
        name: "",
      },
      surveyLanguageCode: ""
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getSchoolList(paginationData));
  }

  onSelectSchool = (data) => {
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": data.value
    }
    this.props.dispatch(assessmentActions.getStudentList(paginationData));
  }


  onSelectClass = (data) => {
    this.setState({ crr_class: data.value });
  }


  onSelectStudent = (data) => {
    let studentId = data.value;


    let { assessment } = this.props
    let { getStudentListData } = assessment;


    let employeeData = {}
    if (getStudentListData && getStudentListData.length > 0) {
      let getIndex = getStudentListData.findIndex(prev => prev.id === studentId);
      if (getIndex !== -1) {
        if (getStudentListData && getStudentListData[getIndex] && getStudentListData[getIndex]["purchaserOrderId"] && getStudentListData[getIndex]["purchaserOrderId"]["employeeId"]) {
          employeeData = {
            ...JSON.parse(JSON.stringify(getStudentListData[getIndex]["purchaserOrderId"]["employeeId"])),
            productId: getStudentListData[getIndex]["purchaserOrderId"]["productId"]
          }
        }
      }
    }

    console.log("employeeData=------>", employeeData)

    if (employeeData && employeeData.emp_id) {
      this.viewReport(employeeData, true)

    }

  }





  handleReport = (ele) => {

    console.log("ele---->", ele)

    let data = {
      employeeId: ele.employeeId
    };
    this.props.dispatch(questionsActions.getAssessmentReportAdmin(data));
    this.props.dispatch(questionsActions.getSurveyTakenDateAdmin(data));
  };

  handleSummaryReport = (ele) => {
    let data = {
      employeeId: ele.employeeId
    };
    this.props.dispatch(questionsActions.getAssessmentReportAdmin(data));
    this.props.dispatch(questionsActions.getSurveyTakenDateAdmin(data));
  };

  handleManagerReport = (ele) => {
    let data = {
      employeeId: ele.employeeId
    };
    this.props.dispatch(questionsActions.getAssessmentReportAdmin(data));
    this.props.dispatch(questionsActions.getSurveyTakenDateAdmin(data));
  };

  handleHiringReport = (ele) => {
    let data = {
      employeeId: ele.employeeId
    };
    this.props.dispatch(questionsActions.getAssessmentReportAdmin(data));
    this.props.dispatch(questionsActions.getSurveyTakenDateAdmin(data));
  };

  handleSchoolReport = (ele) => {
    let data = {
      employeeId: ele.employeeId
    };
    this.props.dispatch(questionsActions.getAssessmentReportAdmin(data));
    this.props.dispatch(questionsActions.getSurveyTakenDateAdmin(data));
  };


  handleSchoolCareer = (ele) => {


    let data4 = {
      employeeId: ele.employeeId,
      surveyId: "666aa3e7e44c722a2beb7ce9"
    }
    this.props.dispatch(assessmentActions.getAptitudeTestScore(data4));


    let data3 = {
      employeeId: ele.employeeId,
      surveyId: "663376deba900057d752056d"
    }
    this.props.dispatch(assessmentActions.getInterestDimensionScore(data3));



    let data1 = {
      employeeId: ele.employeeId,
      surveyId: "66336ca4ba900057d751ff06"
    };
    this.props.dispatch(assessmentActions.getPersonalityIndex(data1));

    let data2 = {
      employeeId: ele.employeeId,
      surveyId: "663a0fae8312d8618444d304"
    }
    this.props.dispatch(assessmentActions.getWorkValueDimensionScore(data2));


    let data5 = {
      employeeId: ele.employeeId
    }
    this.props.dispatch(assessmentActions.getCareerFilamentScore(data5));

    this.props.dispatch(assessmentActions.getTalentPlusEmpAdminStatus(data5));


  };

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  viewReport = (dataX, isComplete) => {
    let ele = {
      ...dataX,
      "employeeId": dataX.id
    }
    if (ele && ele.productId && ele.productId.code) {
      let code = ele.productId.code;
      console.log("code ------------>", code);
      if (isComplete) {
        console.log("ele 1X-->", ele);
        if (code === "Top5TalentplusStrengths") {
          this.handleSummaryReport(ele);
        } else if (code === "TalentPlusStrengths21") {
          this.handleReport(ele);
        } else if (code === "TalentplusManagerStrengths") {
          this.handleManagerReport(ele);
        } else if (code === "TalentPlusHiringStrengths") {
          this.handleHiringReport(ele);
        } else if (code === "Top5TeenTalentplusStrengths") {
          this.handleSchoolReport(ele);
        } else if (code === "TeenCareerGuidance") {
          this.handleSchoolCareer(ele);
        }
        this.setState({ showReportModal: true, crrcode: code, crrEmployeeId: ele.employeeId });
      }
    }

    let temp = {
      emp_id: ele.emp_id,
      name: ele.name,
    };
    this.setState({ crrEmpDetails: temp });

    let temp2 = {
      employeeId: ele.employeeId,
      name: ele.name,
      email: ele.email,
      mobile: ele.mobile,
    };
    this.setState({ crrCodeUserDetails: temp2 });



  };


  render() {

    let { assessment, questions } = this.props
    let { crr_class, showReportModal, crrcode, crrEmpDetails, surveyLanguageCode } = this.state;
    let { getAssessmentReportByEmpIDData, loading, getTranslateElementAllData } = questions;

    let {
      
      getSchoolListData,
      getStudentListData,
      getTalentPlusEmpAdminStatusData,
      getAptitudeTestScoreData,
      getCareerFilamentScoreData,
      getCareerSurveyListData,
      getPersonalityIndexData,
      getWorkValueDimensionScoreData,
      getInterestDimensionScoreData

    } = assessment;




    let colourOptions = [];
    if (getSchoolListData && getSchoolListData.length > 0) {
      colourOptions = getSchoolListData.map((ele) => ({
        value: ele.id,
        label: ele.name
      }))
    }

    const getOnlyClass = (list) => {
      let sectorList = [...new Set(list.map((ele) => (ele.std_class)))]
      return sectorList
    }

    let colourOptionstwo = [];
    if (getStudentListData && getStudentListData.length > 0) {
      colourOptionstwo = getOnlyClass(getStudentListData).map((ele) => ({
        value: ele,
        label: ele
      }))
    }



    let colourOptionsthree = [];
    if (getStudentListData && getStudentListData.length > 0) {
      colourOptionsthree = getStudentListData.filter(prev => prev.std_class === crr_class).map((ele) => ({
        value: ele.id,
        label: ele.name
      }))
    }


    console.log("colourOptionsthree-------->", colourOptionsthree)


    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (
          getTranslateElementAllData &&
          getTranslateElementAllData.length > 0
        ) {
          let getIndex = getTranslateElementAllData.findIndex(
            (prev) => prev.name === name
          );
          if (getIndex !== -1) {
            sentence =
              getTranslateElementAllData &&
                getTranslateElementAllData[getIndex] &&
                getTranslateElementAllData[getIndex]["transl"] &&
                getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode]
                ? getTranslateElementAllData[getIndex]["transl"][
                surveyLanguageCode
                ]
                : "";
          }
        }
        console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode------------>", surveyLanguageCode);
        console.log(
          "getTranslateElementAllData------------>",
          getTranslateElementAllData
        );

        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence =
          element &&
            element["details"] &&
            element["details"]["transl"] &&
            element["details"]["transl"][surveyLanguageCode] &&
            element["details"]["transl"][surveyLanguageCode][name]
            ? element["details"]["transl"][surveyLanguageCode][name]
            : "";
        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    function EditButtonFn(name, text) {
      return <>{GetTextByLanguage(name, text)}</>;
    }
    function EditDetailsFn(element, name, text) {
      return <>{GetDetailsByLanguage(element, name, text)}</>;
    }

    let createdAt =
      getTalentPlusEmpAdminStatusData && getTalentPlusEmpAdminStatusData.createdAt
        ? moment(getTalentPlusEmpAdminStatusData.createdAt)
          .utcOffset("+05:30")
          .format("DD MMMM, YYYY")
        : "";


    return (
      <>
        <StudentHeader />

        <div className="flex items-start justify-center bg-[#F9FAFB]">
          <section className="px-4 mx-auto w-full xl:px-0">

            {/* <div className="flex flex-col items-center justify-between gap-4 p-4 md:flex-row">
              <h1 className="font-semibold md:text-xl text-lg line-clamp-1 text-[#3D405B]">Mountainridge School  | <span className="text-[#2196F3] text-sm font-normal"> School  {">"} Northview Academy</span> </h1>
            </div> */}


            <div className="w-full flex-1 space-y-4">

              <div className="flex flex-col md:flex-row">
                <div className="md:w-1/3 bg-card md:p-8 pt-4 md:border-r space-y-6 top-0 ">
                  <h2 className="text-lg font-semibold mb-4 border-b-2 border-b-[#D9D9D9] pb-2 text-[#212121]">Download Report</h2>

                  <div>
                    <label className="font-medium text-[#212121]/70 text-base before:content-['*'] before:text-[#F14678]">School</label>
                    <div className="relative w-full">
                      <Select className="text-[#212121] text-sm"
                        options={colourOptions}
                        defaultValue={colourOptions[0]}
                        placeholder="Select School"
                        onChange={this.onSelectSchool}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="font-medium text-[#212121]/70 text-base before:content-['*'] before:text-[#F14678]">Class</label>
                    <div className="relative w-full ">
                      <Select className="text-[#212121] text-sm"
                        options={colourOptionstwo}
                        defaultValue={colourOptionstwo[0]}
                        placeholder="Select Class"
                        onChange={this.onSelectClass}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="font-medium text-[#212121]/70 text-base before:content-['*'] before:text-[#F14678]">Student</label>
                    <div className="relative w-full ">
                      <Select className="text-[#212121] text-sm"
                        options={colourOptionsthree}
                        defaultValue={colourOptionsthree[0]}
                        placeholder="Select Student"
                        onChange={this.onSelectStudent}
                      />
                    </div>
                  </div>

                  <div className="space-y-5 pt-4">
                    <button className="bg-[#2196F3] text-white p-2 rounded-md w-full">APPLY</button>
                    <button className="bg-[#212121] text-white p-2 rounded-md w-full">DOWNLOAD PDF</button>
                  </div>
                </div>




                {showReportModal ?
                  <>
                    <section className="md:w-2/3 mt-6 md:mt-0 bg-white space-y-5">

                      {crrcode === "TalentPlusStrengths21" ? (
                        <>
                          <AssessmentReport
                            closeReportModal={this.closeReportModal}
                            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                            getAssessmenrEmployeeDetailsData={crrEmpDetails}
                            createdAt={createdAt}
                            EditButtonFn={EditButtonFn}
                            EditDetailsFn={EditDetailsFn}
                            handleDownloadStatus={() => { }}
                            loading={loading}
                            isUser={false}
                          />
                        </>
                      ) : null}

                      {crrcode === "Top5TalentplusStrengths" ? (
                        <>
                          <AssessmentSummary
                            closeReportModal={this.closeReportModal}
                            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                            getAssessmenrEmployeeDetailsData={crrEmpDetails}
                            createdAt={createdAt}
                            EditButtonFn={EditButtonFn}
                            EditDetailsFn={EditDetailsFn}
                            handleDownloadStatus={() => { }}
                            loading={loading}
                            isUser={false}
                          />
                        </>
                      ) : null}

                      {crrcode === "TalentplusManagerStrengths" ? (
                        <>
                          <AssessmentManagerReport
                            closeReportModal={this.closeReportModal}
                            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                            getAssessmenrEmployeeDetailsData={crrEmpDetails}
                            createdAt={createdAt}
                            EditButtonFn={EditButtonFn}
                            EditDetailsFn={EditDetailsFn}
                            handleDownloadStatus={() => { }}
                            loading={loading}
                            isUser={false}
                          />
                        </>
                      ) : null}

                      {crrcode === "TalentPlusHiringStrengths" ? (
                        <AssessmentHiringReport
                          closeReportModal={this.closeReportModal}
                          getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                          getAssessmenrEmployeeDetailsData={crrEmpDetails}
                          createdAt={createdAt}
                          EditButtonFn={EditButtonFn}
                          EditDetailsFn={EditDetailsFn}
                          handleDownloadStatus={() => { }}
                          loading={loading}
                          isUser={false}
                        />
                      ) : null}

                      {crrcode === "Top5TeenTalentplusStrengths" ? (
                        <AssessmentReportSchool
                          closeReportModal={this.closeReportModal}
                          getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                          getAssessmenrEmployeeDetailsData={crrEmpDetails}
                          createdAt={createdAt}
                          EditButtonFn={EditButtonFn}
                          EditDetailsFn={EditDetailsFn}
                          handleDownloadStatus={() => { }}
                          loading={loading}
                          isUser={false}
                        />
                      ) : null}

                      {crrcode === "TeenCareerGuidance" ? (
                        <AssessmentReportCareer
                          closeReportModal={this.closeReportModal}
                          getAssessmenrEmployeeDetailsData={crrEmpDetails}
                          createdAt={createdAt}
                          EditButtonFn={EditButtonFn}
                          EditDetailsFn={EditDetailsFn}
                          handleDownloadStatus={() => { }}
                          loading={loading}
                          isUser={false}

                          getCareerFilamentScoreData={getCareerFilamentScoreData}
                          getCareerSurveyListData={getCareerSurveyListData}
                          getPersonalityIndexData={getPersonalityIndexData}
                          getAptitudeTestScoreData={getAptitudeTestScoreData}
                          getWorkValueDimensionScoreData={getWorkValueDimensionScoreData}
                          getInterestDimensionScoreData={getInterestDimensionScoreData}

                        />
                      ) : null}

                    </section>
                  </> :

                  <section className="md:w-2/3 mt-6 md:mt-0 bg-white space-y-5">

                    <div className="flex flex-col items-center justify-between space-y-10 md:w-9/12 w-full mx-auto border">
                      <div className="space-y-8 text-center flex flex-col items-center">
                        <div className="flex justify-center items-center pt-10 w-full">
                          <img src="/img/TalentPlusStrengths_logo.svg" className="object-cover w-56" alt="default_survey_logo" />
                          <div />
                        </div>

                        <div className="space-y-4 text-center w-full">
                          <div className="text-5xl text-[#212121] font-normal text-centers">
                            <p className="pb-2">Student Assessment</p>
                            <p className=""> Report - 2024</p>
                          </div>
                          <p className="text-base font-medium text-[#212121]/80 italic">John Smith | 1 August, 2022</p>
                        </div>
                        <div className="flex justify-center">
                          {/* <img src="/img/employee-wellness-report.webp" className="w-full h-full mx-auto" /> */}
                          <img src="/assessment_images/School/employee-wellness-report.webp" alt="employee-wellness-report" class="w-full h-full" />
                        </div>
                        <div class="text-center space-y-2 pt-6 pb-20">
                          <p class="text-lg text-[#212121] font-medium">
                            {"Powered by HappyPlus © 2024"}
                          </p>
                          <p class="text-sm text-[#212121]/80">
                            {"This report is confidential and should not be distributed without permission"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </section>}







              </div>

            </div>

            {/* Data not Found section */}
            {/* <section className="flex items-center justify-center w-full col-span-2 gap-10 px-4 mx-auto overflow-hidden">
                <div className="flex flex-col items-center space-y-4 justify-center md:py-10 py-8 text-center">
                  <img src="/assessment_images/no-users.svg" alt="no-users.svg" className="w-3/6 2xl:w-2/4" />
                  <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Data not found!</h2>
                  <p className="text-gray-500 text-lg">Looks like you haven’t added any user yet.</p>
                  <div onClick={() => this.handleNewSchoolModal(true)} className="mt-0 md:mt-4 bg-[#2196F3] border border-[#2196F3] text-white py-2 px-5 rounded uppercase flex items-center justify-center space-x-3">
                    <span><svg width="30" height="30" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3281 40H50.3281M40.3281 30V50M10.3281 40C10.3281 43.9397 11.1041 47.8407 12.6117 51.4805C14.1194 55.1203 16.3292 58.4274 19.1149 61.2132C21.9007 63.999 25.2079 66.2087 28.8476 67.7164C32.4874 69.224 36.3885 70 40.3281 70C44.2678 70 48.1689 69.224 51.8086 67.7164C55.4484 66.2087 58.7556 63.999 61.5413 61.2132C64.3271 58.4274 66.5369 55.1203 68.0445 51.4805C69.5522 47.8407 70.3281 43.9397 70.3281 40C70.3281 36.0603 69.5522 32.1593 68.0445 28.5195C66.5369 24.8797 64.3271 21.5726 61.5413 18.7868C58.7556 16.001 55.4484 13.7913 51.8086 12.2836C48.1689 10.776 44.2678 10 40.3281 10C36.3885 10 32.4874 10.776 28.8476 12.2836C25.2079 13.7913 21.9007 16.001 19.1149 18.7868C16.3292 21.5726 14.1194 24.8797 12.6117 28.5195C11.1041 32.1593 10.3281 36.0603 10.3281 40Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></span>
                    <button className="">Add New School</button>
                  </div>
                </div>
              </section> */}


          </section>
        </div>

      </>
    );
  }
}

StudentReports.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(StudentReports);
